<template>
    <div class="review-company">
        <img
            class="review-company__logo"
            :src="imageSrc"
            :alt="typeOfCompany"
        >

        <component
            :is="typeOfStars"
            :stars="numberOfStars"
            :content="content.stars"
            :class="checkDarkMode"
        />

        <zoe-atom-text
            v-if="content.showAmount.value && stringIsNotEmpty(content.reviewsText.value)"
            :item="content.reviewsText.value"
            class="review-company__reviews"
        />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { componentProps } from '../../../../mixins/component/component';
import { stringIsNotEmpty } from '../../../../../../resources/frontend/js/mixins/get-page-data';
import ZoeAtomText from '../../../atoms/text/v1.0.0/zoe-atom-text.vue';
import ZoeAtomFacebookStars from '../../../atoms/stars/variation-facebook/v1.0.0/zoe-atom-facebook-stars.vue';
import ZoeAtomGoogleStars from '../../../atoms/stars/variation-google/v1.0.0/zoe-atom-google-stars.vue';
import ZoeAtomTrustpilotStars from '../../../atoms/stars/variation-trustpilot/v1.0.0/zoe-atom-trustpilot-stars.vue';
import ZoeAtomYelpStars from '../../../atoms/stars/variation-yelp/v1.0.0/zoe-atom-yelp-stars.vue';

const props = defineProps(componentProps);

const typeOfCompany = computed(() => {
    return props.content.company.value;
});

const imageSrc = computed(() => {
    if (props.content?.darkMode?.value && (typeOfCompany.value === 'trustpilot')) {
        return new URL(`../../../../../../resources/images/logos/${typeOfCompany.value}-darkmode.svg`, import.meta.url).href;
    }
    return new URL(`../../../../../../resources/images/logos/${typeOfCompany.value}.svg`, import.meta.url).href;
});

const typeOfStars = computed(() => {
    switch (typeOfCompany.value) {
        case 'facebook':
            return ZoeAtomFacebookStars;
        case 'google':
            return ZoeAtomGoogleStars;
        case 'trustpilot':
            return ZoeAtomTrustpilotStars;
        case 'yelp':
            return ZoeAtomYelpStars;
        default:
            return null;
    }
});

const numberOfStars = computed(() => {
    return `${props.content.stars.value}`;
});

const checkDarkMode = computed(() => {
    return props.content?.darkMode?.value ? 'review-company--dark-mode' : '';
});
</script>

<style lang="scss" scoped>
@use 'zoe-molecule-review-company';
</style>
